const { logger } = require('./loggerWithHandlers');

module.exports = {
  logger,
};
